import toursReducer from "../service/tours/toursSlice";
import categoriesReducer from "../service/categories/categoriesSlice";
import toursAvailableDatesReducer from "../service/tours/toursAvailableDatesSlice";
import toursDetailsReducer from "../service/tours/toursDetailsSlice";
import attendanceReducer from "../service/attendance/attendanceSlice";
import sendOTPSlice from "../service/otp/sendOTPSlice";
import verifyOTPSlice from "../service/otp/verifyOTPSlice";
import bookingReducer from "../service/bookings/bookingsSlice";
import toursDetailsAfterBookingReducer from "../service/tours/toursDetailsAfterBookingSlice";
import categoriesAfterBookingReducer from "../service/categories/categoriesAfterBookingSlice";
import toursStatusReducer from "../service/tours/toursStatusSlice";
import updateAttendanceReducer from "../service/attendance/updateAttendanceSlice"; // Adjust the path
import sendEmailReducer from "../service/otp/sendEmailSlice";
import venuesReducer from "../service/venues/venuesSlice";
const reducers = {
  tours: toursReducer,
  categories: categoriesReducer,
  toursAvailableDates: toursAvailableDatesReducer,
  toursDetails: toursDetailsReducer,
  attendance: attendanceReducer,
  sendOTP: sendOTPSlice,
  verifyOTP: verifyOTPSlice,
  bookings: bookingReducer,
  toursDetailsAfterBooking: toursDetailsAfterBookingReducer,
  categoriesAfterBooking: categoriesAfterBookingReducer,
  toursStatus: toursStatusReducer,
  updateAttendance: updateAttendanceReducer,
  email: sendEmailReducer,
  venues: venuesReducer,
};

export default reducers;
